import CommonConfirmModal from ".";
import WithFnModalComponent from "../FunctionModal";

export const ConfirmModal = WithFnModalComponent(
  CommonConfirmModal,
  "confirmModal"
);
export function customConfirm({ title, okText, cancelText }: { title: string; okText?: string; cancelText?: string }) {
  return new Promise((resolve, reject) => {
    ConfirmModal({
      title: title,
      okText: okText,
      cancelText: cancelText,
      onOk: (isShowAgin: boolean) => {

        resolve(true);
      },
      onCancel: (isShowAgin: boolean) => {
        resolve(false);
      },
    });
  });
}
